import { initRoutes } from '@eidellev/adonis-stardust/client';
initRoutes();

import './modules/accordion';
import './modules/collection/instant-search';
import './modules/collection/filters';
import './modules/collection/view-toggle';
import './modules/ring-assistant';
